import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    getAuthFeatureFlags,
    getAuthFeatureFlagsErrorMessage,
    getAuthFeatureFlagsRequestState,
} from '../../../../selectors/authFeatureFlags.selectors';
import authFeatureFlagsActionCreators from '../authFeatureFlagsActionCreators';

export const useSetFeatureFlagsEffect = () => {
    const dispatch = useDispatch();

    const authFeatureFlags = useSelector(getAuthFeatureFlags);
    const requestState = useSelector(getAuthFeatureFlagsRequestState);
    const errorMessage = useSelector(getAuthFeatureFlagsErrorMessage);

    React.useEffect(() => {
        dispatch(authFeatureFlagsActionCreators.setAuthFeatureFlags());
    }, []);

    return {
        authFeatureFlags,
        requestState,
        errorMessage,
    };
};
